module.exports = __webpack_public_path__ + "img/good_pressed.262795db.png";